"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mainNav = void 0;

var _swatches = require("../swatches");

var _base = require("./base");

var mainNav = {
  headerColor: _swatches.monochrome.black,
  controlIconColor: "rgba(".concat(_swatches.monochrome.mediumDark_rgba, ", 0.75)"),
  controlIconColorHover: _swatches.monochrome.mediumDark,
  controlIconHoverBackgroundOpacity: 1,
  background: _swatches.monochrome.superLight,
  color: _swatches.monochrome.black,
  highlightColor: _base.primary.brand,
  itemBackgroundActive: _swatches.monochrome.medium,
  itemBackgroundHover: "rgba(".concat(_swatches.monochrome.medium_rgba, ", 0.5)"),
  iconColor: _swatches.monochrome.dark,
  alertColor: "rgba(".concat(_swatches.monochrome.dark_rgba, ", 0.7)"),
  alertColorHover: _swatches.monochrome.dark,
  alertColorActive: _swatches.monochrome.dark,
  countColor: "rgba(".concat(_swatches.monochrome.black_rgba, ", 0.7)"),
  countColorHover: _swatches.monochrome.black,
  countColorActive: _swatches.monochrome.black,
  clickableOpacity: 0.7,
  clickableOpacityHover: 1,
  clickableOpacityActive: 1,
  pin: _base.primary.warning,
  dividerColor: _swatches.monochrome.medium,
  optionsBtnBackgroundHover: _swatches.monochrome.superLight,
  optionsIconColor: _swatches.monochrome.mediumDark,
  warningIconColor: _base.primary.negative,
  composeButtonColor: _base.primary.brand,
  composeButtonBackground: _swatches.monochrome.white,
  composeButtonBorder: _swatches.monochrome.light,
  composeButtonColorHover: _base.primary.brand,
  composeButtonBackgroundHover: _swatches.monochrome.white,
  composeButtonBorderHover: _base.primary.brand
};
exports.mainNav = mainNav;
//# sourceMappingURL=mainNav.js.map